import React, { Component } from "react"
import PropTypes from "prop-types"
import COLOR_PALETTE from "constants/color-palette"
import Radium from "higher-order-components/configured-radium/"
import { getState } from "radium"

class ColoredLabel extends Component {
  render() {
    const {
      label, color = COLOR_PALETTE.GRAY_LIGHT, style, hoverLabel = undefined
    } = this.props
    const hoverStatus = getState(this.state, "ColoredLabel", ":hover")
    return (
      <span
        ref={"ColoredLabel"}
        data-test="stock-type"
        style={[
          {
            ...{
              backgroundColor: color,
              color: "#fff",
              display: "inline-block",
              letterSpacing: ".15em",
              textTransform: "uppercase",
              fontWeight: 900,
              fontSize: "70%",
              padding: ".5em .9em .35em 1em",
              borderRadius: "1em",
              transition: "background-color 250ms linear",
              ":hover": {}
            }
          },
          { ...style }
        ]}>
        {hoverLabel && hoverStatus && hoverLabel}
        {(!hoverLabel || !hoverStatus) && label}
      </span >
    )
  }
}

ColoredLabel.propTypes = {
  label: PropTypes.node,
  color: PropTypes.string,
  style: PropTypes.object,
  hoverLabel: PropTypes.node
}

export default Radium(ColoredLabel)



// WEBPACK FOOTER //
// ./src/containers/colored-label/index.jsx